export const faqs = [
  {
    id: "faq-source",
    question: "你们的爆料内容主要来自哪些渠道？",
    answer:
      "主要来自可公开检索的材料：监管公告、法庭文书、招标与采购记录、企业年报、行业期刊，以及读者提供的线索。所有稿件都会标注信息来源类型，并在文末列出可核对的依据，尽量让读者能顺着线索自行验证。",
  },
  {
    id: "faq-verify",
    question: "涉及具体个人和机构时，你们如何做事实核对？",
    answer:
      "我们采用两轮核对：先由撰稿人完成材料交叉比对，再由编辑独立复核关键时间、金额与名称。对无法确认的细节，稿件中会明确标注为『存疑』或『尚未证实』，不会用推测充当结论。若当事方提出有效异议，我们会在文末更新说明。",
  },
  {
    id: "faq-update",
    question: "已经发布的稿件还会更新吗？",
    answer:
      "会。政经事件往往持续演变，我们为重要稿件建立追踪档案。当出现新进展、新文件或官方回应时，会在原文顶部标注更新日期，并把新增内容放在『进展更新』板块中，旧内容不做删改，方便读者对照。",
  },
  {
    id: "faq-anonymous",
    question: "我可以匿名提供线索吗？",
    answer:
      "可以。你可以通过联系页面的线索投递表单提交材料，只需留下一个可用的联络邮箱以便我们核查细节，不必填写真实姓名。我们会严格保护线索来源，未经提供者同意不会对外透露任何可识别身份的信息。",
  },
  {
    id: "faq-correct",
    question: "如果我发现内容有误，应该怎么办？",
    answer:
      "非常欢迎指正。请在联系页面说明具体是哪一篇稿件、哪一处表述，并附上可佐证的材料。编辑会在两个工作日内回复。经核实确属错误的，我们会更正原文并注明更正时间与原因。",
  },
  {
    id: "faq-different",
    question: "美日吃瓜和其他资讯站有什么不同？",
    answer:
      "我们不做标题党式的碎片速览，而是围绕一个具体事件做完整的档案梳理：把时间线、资金流向、关键人物关系与监管回应放在同一篇稿件里。栏目固定在政客丑闻、财阀内幕、官员贪腐、选举黑幕、企业造假与学术不端六条线上。",
  },
];